import React from 'react';
import '@trp-beacon-ui-kit/foundation/style-tokens/css/variables.css';
import '@trp-beacon-ui-kit/foundation/fonts/fonts.css';
import { Box } from '@trp-individual-investor-adv-svc/ii-prosp-components';

import ServiceErrorCard from '../shared/ServiceErrorCard';
import AppErrorAlert from '../shared/AppAlerts/AppErrorAlert';
import { dispatchOverlayLoad } from '../shared/Analytics';
import { showModal, showYodleeModal } from '../../Utils.js';
import YodleeAlert from '../shared/YodleeAlert/YodleeAlert';

const HubPageBase = ({
    state,
    children,
    serviceError,
    popupAlertText,
    popupAlertTitle,
    popUpError,
    popupClose,
    dispatch,
    white,
    keepInv,
    noInvModal,
}) => {
    const isOutstandingInvite = state?.pendingInvite !== null;
    const encodedUrlText = state?.pendingInvite?.encodedUrlText;
    const isPLDL =
        state?.planningGroup?.activeEngagement?.engagementStatuses[0].status === 'PLDL';
    const showYodleeError = showYodleeModal(state) && !isPLDL;

    React.useEffect(() => {
        if (encodedUrlText && isOutstandingInvite && !noInvModal) {
            showModal('outstanding-coclient-invite');
            dispatchOverlayLoad('Outstanding CoClient Invite Modal');
        }
        if (!keepInv) {
            sessionStorage.removeItem('emailInv');
        }
    }, [encodedUrlText, dispatch, isOutstandingInvite, keepInv]);

    React.useEffect(() => {
        if (
            state?.activeActions &&
            state?.activeActions?.some((action) => action.actionType === 'ACCOUNT_SELECTION')
        ) {
            const acctSelectionModal = document.getElementById('acct-selection');
            if (acctSelectionModal !== null) {
                showModal('acct-selection');
                dispatchOverlayLoad('Primary Consent 1 Modal');
            }
        }
        if (
            state?.activeActions &&
            state?.activeActions?.some((action) => action.actionType === 'E_DELIVERY')
        ) {
            const eDeliveryModal = document.getElementById('e-delivery');
            if (eDeliveryModal !== null) {
                showModal('e-delivery');
                dispatchOverlayLoad('E Delivery Consent Modal');
            }
        }
    }, [state?.activeActions]);

    return (
        <>
        {popUpError && (
            <AppErrorAlert
                dialogText={popupAlertText}
                dialogTitle={popupAlertTitle}
                close={popupClose}
            />
            )}
            {serviceError ? (
                <Box>
                    <ServiceErrorCard showButton />
                </Box>
            ) : (
                <Box
                    className="beacon-theme-modern-outlook"
                    id="hub-page-container"
                    sx={{
                        paddingBottom: { xs: '64px', md: '160px' },
                        width: '100%',
                        backgroundColor: white ? '#FFFFFF' : '#F4F5F6',
                    }}>
                    {showYodleeError && (
                        <Box
                            className="b-container-content"
                            sx={{ padding: '48px 16px 0 16px', inlineSize: 'unset !important' }}>
                            <YodleeAlert dispatch={dispatch} />
                        </Box>
                    )}
                    {children}
                </Box>
            )}
        </>
    );
};

export default HubPageBase;
